import React, { useEffect, useState } from "react";
import wallet from "../../images/Icons/wallet.png";
import arrow from "../../images/Icons/arrow-up.png";
import { useDispatch, useSelector } from "react-redux";
import { fetchCashWallet } from "../../redux/slice/cashWallet";
import { fetchCreditWallet } from "../../redux/slice/creditWallet";
import Pagination from "../../Component/Pagination";
import NumberFormatter from "../../Component/NumberFormatter";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import config from "../../config";
import useLogout from "../Auth/useLogout";
import NoData from "../../Component/NoData";
import Dataloader from "../../Component/Dataloader";
import { hasPermission, hasWalletAccess } from "../../utils/permissionUtils";
import { toast } from "react-toastify";

export default function Wallet() {
  const navigate = useNavigate();
  const [type, setType] = useState(() => {
    // Set initial type based on permissions
    if (hasPermission('wallet', 'cash-wallet')) {
      return 'cash';
    } else if (hasPermission('wallet', 'credit-wallet')) {
      return 'credit';
    } else {
      return 'cash'; // default
    }
  });
  
  // Check if user has permission to access this page
  useEffect(() => {
    if (!hasWalletAccess()) {
      navigate('/');
      toast.error('You do not have permission to access this page', {
        position: "top-right",
        autoClose: 3000,
      });
    }
  }, [navigate]);
  
  const dispatch = useDispatch();
  const logout = useLogout();
  const { cashWalletData, cashAmount, isError } = useSelector(
    (state) => state.cashWallet
  );
  const { creditWalletData, creditAmount, assignedAmount, isError1 } =
    useSelector((state) => state.creditWallet);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      if (!isError && !isError1) {
        setLoading(true);
        try {
          await dispatch(fetchCashWallet(logout));
          await dispatch(fetchCreditWallet(logout));
        } catch (error) {
        } finally {
          setLoading(false);
        }
      }
    };
    fetchData();
  }, [dispatch, isError, isError1, logout]);

  const handleType = (type) => {
    // Check permissions before switching wallet types
    if (type === 'cash' && !hasPermission('wallet', 'cash-wallet')) {
      toast.error('You do not have permission to access cash wallet', {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }
    
    if (type === 'credit' && !hasPermission('wallet', 'credit-wallet')) {
      toast.error('You do not have permission to access credit wallet', {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }
    
    setType(type);
  };
  const [currentPage, setCurrentPage] = useState(1);
  const itemPerPage = 5;
  const totalPage = Math.ceil(cashWalletData.length / itemPerPage);
  const getCashData = () => {
    const startIndex = (currentPage - 1) * itemPerPage;
    const endIndex = startIndex + itemPerPage;
    return cashWalletData.slice(startIndex, endIndex);
  };
  const getCreditData = () => {
    const startIndex = (currentPage - 1) * itemPerPage;
    const endIndex = startIndex + itemPerPage;
    return creditWalletData.slice(startIndex, endIndex);
  };
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const [creditHistory, setCreditHistory] = useState([]);
  useEffect(() => {
    const fetchCreditHistory = async () => {
      try {
        const response = await axios.get(
          `${config.apiUrl}/credit-wallet-request`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: config.token,
              Accept: "application/json",
            },
          }
        );
        setCreditHistory(response.data.data);
      } catch (error) {
        if (error.response && error.response.status === 401) {
          logout();
        }
      }
    };
    fetchCreditHistory();
  }, [logout]);

  return (
    <>
      <div className="page-content">
        <div className="container-fluid">
          <div className="row-layout mrb1">
            {loading ? (
              <div className="d-flex justify-content-center">
                <Dataloader />
              </div>
            ) : (
              <>
                <div className="row-hd-txt">
                  <div className="row-hd-txt-left">
                    <img src={wallet} alt="icon" />
                    <h5>My Wallet</h5>
                  </div>
                  <div className="wlt_typ_btn">
                    {hasPermission('wallet', 'cash-wallet') && (
                      <button
                        className={`btn cash ${type === "cash" ? "active" : ""}`}
                        type="button"
                        onClick={() => handleType("cash")}
                      >
                        Cash
                      </button>
                    )}
                    {hasPermission('wallet', 'credit-wallet') && (
                      <button
                        className={`btn credit ${
                          type === "credit" ? "active" : ""
                        }`}
                        type="button"
                        onClick={() => handleType("credit")}
                      >
                        Credit
                      </button>
                    )}
                  </div>
                </div>
                <p className="order-note">
                  <span>Note - </span>View all transactions, manage cash and
                  credit balances, and track your payment activity effortlessly
                  in one place.
                </p>
                {type === "cash" ? (
                  <div className="row g-3">
                    <div className="col-lg-6 col-md-6">
                      <div className="row wlt-card">
                        <div className="col-lg-12 p-0">
                          <div className="card cash">
                            <div className="card-body">
                              <div className="topr">
                                <h4>My Wallet</h4>
                                <div className="topr-shape"></div>
                              </div>
                              <h6 className="text-white mb-2">Cash Balance</h6>
                              <div className="price">
                                <i className="bi bi-currency-rupee"></i>
                                <h4 className="amt">
                                  <NumberFormatter number={cashAmount} />
                                </h4>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <div className="transaction_area">
                        <div className="row-hd-txt">
                          <div className="row-hd-txt-left">
                            <h6 className="mb-0">Transactions</h6>
                          </div>
                        </div>
                        {getCashData().length > 0 ? (
                          <>
                            <div className="table-responsive">
                              <table className="table txn-dtl border-top">
                                <tbody>
                                  {getCashData().map((cash, index) => {
                                    return (
                                      <tr key={index}>
                                        <td>
                                          <div className="left">
                                            <img
                                              src={arrow}
                                              alt=""
                                              className={`img ${
                                                cash.status === "debit"
                                                  ? "out"
                                                  : "in"
                                              }`}
                                            />
                                          </div>
                                        </td>
                                        <td>
                                          <p>{cash.description}</p>
                                          <span className="dt">
                                            {cash.transaction_id}
                                          </span>
                                          {","}&nbsp;
                                          <span className="date">
                                            {cash.created_at}
                                          </span>
                                        </td>
                                        <td>
                                          <p className="price">
                                            Rs{" "}
                                            <NumberFormatter
                                              number={cash.amount}
                                            />
                                          </p>
                                          <p className="status">
                                            {cash.status}
                                          </p>
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </div>
                            <Pagination
                              totalPages={totalPage}
                              currentPage={currentPage}
                              onPageChange={handlePageChange}
                            />{" "}
                          </>
                        ) : (
                          <NoData />
                        )}
                      </div>
                    </div>
                  </div>
                ) : (
                  <>
                    <div className="row g-3">
                      <div className="col-lg-6 col-md-6">
                        <div className="row wlt-card">
                          <div className="col-lg-12 p-0">
                            <div className="card credit">
                              <div className="card-body">
                                <div className="topr">
                                  <h4>My Wallet</h4>
                                  <div className="topr-shape"></div>
                                </div>
                                <div className="row">
                                  <div className="col-6 border-end">
                                    <h6 className="text-white mb-2">
                                      Credit Balance
                                    </h6>
                                    <div className="credit_price m-0">
                                      <i className="bi bi-currency-rupee"></i>
                                      <h4 className="amt">
                                        <NumberFormatter
                                          number={creditAmount}
                                        />
                                      </h4>
                                    </div>
                                  </div>
                                  <div className="col-6">
                                    <h6 className="text-white mb-2">
                                      Assigned Balance
                                    </h6>
                                    <div className="credit_price m-0">
                                      <i className="bi bi-currency-rupee"></i>
                                      <h4 className="amt">
                                        <NumberFormatter
                                          number={assignedAmount}
                                        />
                                      </h4>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          {assignedAmount <= 0 && (
                            <div className="col-12">
                              <div className="btn-grp">
                                <Link
                                  to="/credit-request"
                                  state={{ assignedAmount }}
                                  type="button"
                                  className="txn-btn add"
                                >
                                  <i className="bi bi-plus-lg me-1"></i>
                                  <span>Request For Credit Amount</span>
                                </Link>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6">
                        <div className="transaction_area">
                          <div className="row-hd-txt">
                            <div className="row-hd-txt-left">
                              <h6 className="mb-0">Transactions</h6>
                            </div>
                          </div>
                          {getCreditData().length > 0 ? (
                            <>
                              <div className="table-responsive">
                                <table className="table txn-dtl border-top">
                                  <tbody>
                                    {getCreditData().map((credit, index) => {
                                      return (
                                        <tr key={index}>
                                          <td>
                                            <div className="left">
                                              <img
                                                src={arrow}
                                                alt=""
                                                className={`img ${
                                                  credit.status === "debit"
                                                    ? "out"
                                                    : "in"
                                                }`}
                                              />
                                            </div>
                                          </td>
                                          <td>
                                            <p>{credit.description}</p>
                                            <span className="dt">
                                              {credit.transaction_id}
                                            </span>
                                            {","}&nbsp;
                                            <span className="date">
                                              {credit.created_at}
                                            </span>
                                          </td>
                                          <td>
                                            <p className="price">
                                              Rs{" "}
                                              <NumberFormatter
                                                number={credit.amount}
                                              />
                                            </p>
                                            <p className="status">
                                              {credit.status}
                                            </p>
                                          </td>
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </table>
                              </div>
                              <Pagination
                                totalPages={totalPage}
                                currentPage={currentPage}
                                onPageChange={handlePageChange}
                              />{" "}
                            </>
                          ) : (
                            <NoData />
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="row credit-history">
                      <div className="col-lg-12">
                        <h6 className="title">Your Credit Request History:</h6>
                        <div className="table-responsive">
                          <table className="table table-bordered">
                            <thead>
                              <tr>
                                {/* <th>Reference Number</th> */}
                                <th>Wallet Document Type</th>
                                <th>Form Details</th>
                                <th>Status</th>
                                <th>Date</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {creditHistory.map((hist, hist_index) => {
                                return (
                                  <tr key={hist_index}>
                                    {/* <td>{hist.reference_number || 'N/A'}</td> */}
                                    <td>{hist.wallet_document_type_name}</td>
                                    <td>
                                      {hist.form_data.map((field, field_index) => {
                                        return (
                                          <div key={field_index}>
                                            <strong>{field.label}:</strong>{' '}
                                            {field.type === 'file' ? (
                                              <a 
                                                href={field.value} 
                                                target="_blank" 
                                                rel="noopener noreferrer"
                                                className="text-primary"
                                              >
                                                View Document
                                              </a>
                                            ) : (
                                              <span>{field.value}</span>
                                            )}
                                          </div>
                                        );
                                      })}
                                    </td>
                                    <td>
                                      <span className={`badge ${
                                        hist.status === 'Approved' ? 'bg-success' : 
                                        hist.status === 'Rejected' ? 'bg-danger' : 
                                        'bg-warning'
                                      }`}>
                                        {hist.status}
                                      </span>
                                    </td>
                                    <td>
                                      <strong>Created At:</strong> {hist.created_at}
                                      <br />
                                      <strong>Updated At:</strong> {hist.updated_at}
                                    </td>
                                    <td>
                                      {(hist.status === 'Rejected' || hist.status === 'Pending') && (
                                        <Link 
                                          to={`/credit-request/${hist.id}`}
                                          className="btn btn-sm btn-primary"
                                        >
                                          <i className="bi bi-pencil-square me-1"></i>
                                          Edit
                                        </Link>
                                      )}
                                    </td>
                                  </tr>
                                );
                              })}
                              {creditHistory.length === 0 && (
                                <tr>
                                  <td
                                    className="text-danger text-center"
                                    colSpan={5}
                                  >
                                    No History Available
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
